<template>
  <validation-observer ref="formObserver" v-slot="{ passes }" tag="div">
    <form @submit="passes(emitSubmit($event))" v-bind="$attrs">
      <slot />
    </form>
  </validation-observer>
</template>

<script>
export default {
  methods: {
    emitSubmit(event) {
      this.$emit('submit', event)
    },

    setErrors(errors) {
      this.$refs.formObserver.setErrors(errors);
    }
  }
}
</script>